import { CompanyInfo, Config } from '@websky/core/src/context';
import { getLocale } from '@websky/core/src/utils';
import i18next from 'i18next';
import { Card, CardType } from '@websky/core/src/PromoLoader/types';
import { PassengerTypeConfig } from '@websky/core/src/SearchForm/types';
import { Steps } from '@websky/core/src/Stepbar/types';
import { doctorContentIcon, doctorHeaderIcon, medical_insurance } from './components/CheckoutAdditionalService/icons';
import { OauthServiceType } from '@websky/graphql';
import { kk } from './locales/kk';
import { Sorting } from '@websky/core/src/Results/enums';

const currentLocale = getLocale() as string;
const isProd = process.env.NODE_ENV === 'production';

const passTypeRoutes = [
	[
		{
			departure: 'VVO',
			arrival: 'AER'
		}
	],
	[
		{
			departure: 'AER',
			arrival: 'VVO'
		}
	],
	[
		{
			departure: 'VVO',
			arrival: 'PKC'
		}
	],
	[
		{
			departure: 'PKC',
			arrival: 'VVO'
		}
	],
	[
		{
			departure: 'KHV',
			arrival: 'AER'
		}
	],
	[
		{
			departure: 'AER',
			arrival: 'KHV'
		}
	],
	[
		{
			departure: 'UUS',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'UUS'
		}
	],
	[
		{
			departure: 'VVO',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'VVO'
		}
	],
	[
		{
			departure: 'PKC',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'PKC'
		}
	],
	[
		{
			departure: 'KHV',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'KHV'
		}
	],
	[
		{
			departure: 'HTA',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'HTA'
		}
	],
	[
		{
			departure: 'UUD',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'UUD'
		}
	],
	[
		{
			departure: 'UUD',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'UUD'
		}
	],
	[
		{
			departure: 'EGO',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'EGO'
		}
	],
	[
		{
			departure: 'VOZ',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'VOZ'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'IJK',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'IJK'
		}
	],
	[
		{
			departure: 'KZN',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'KZN'
		}
	],
	[
		{
			departure: 'KVX',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'KVX'
		}
	],
	[
		{
			departure: 'MCX',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'MCX'
		}
	],
	[
		{
			departure: 'NBC',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'NBC'
		}
	],
	[
		{
			departure: 'GOJ',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'GOJ'
		}
	],
	[
		{
			departure: 'OMS',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'OMS'
		}
	],
	[
		{
			departure: 'OSW',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'OSW'
		}
	],
	[
		{
			departure: 'PEZ',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'PEZ'
		}
	],
	[
		{
			departure: 'PEE',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'PEE'
		}
	],
	[
		{
			departure: 'KUF',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'KUF'
		}
	],
	[
		{
			departure: 'RTW',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'RTW'
		}
	],
	[
		{
			departure: 'TJM',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'TJM'
		}
	],
	[
		{
			departure: 'UFA',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'UFA'
		}
	],
	[
		{
			departure: 'CEK',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'CEK'
		}
	],
	[
		{
			departure: 'IAR',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'IAR'
		}
	],
	[
		{
			departure: 'LPK',
			arrival: 'SIP'
		}
	],
	[
		{
			departure: 'SIP',
			arrival: 'LPK'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'SKX'
		}
	],
	[
		{
			departure: 'SKX',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'KGD'
		}
	],
	[
		{
			departure: 'KGD',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'HTA',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'HTA'
		}
	],
	[
		{
			departure: 'HTA',
			arrival: 'AER'
		}
	],
	[
		{
			departure: 'AER',
			arrival: 'HTA'
		}
	],
	[
		{
			departure: 'YKS',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'YKS'
		}
	],
	[
		{
			departure: 'MJZ',
			arrival: 'SVX'
		}
	],
	[
		{
			departure: 'SVX',
			arrival: 'MJZ'
		}
	],
	[
		{
			departure: 'YKS',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'YKS'
		}
	],
	[
		{
			departure: 'MJZ',
			arrival: 'LED'
		}
	],
	[
		{
			departure: 'LED',
			arrival: 'MJZ'
		}
	],
	[
		{
			departure: 'IKT',
			arrival: 'AER'
		}
	],
	[
		{
			departure: 'AER',
			arrival: 'IKT'
		}
	],
	[
		{
			departure: 'YKS',
			arrival: 'AER'
		}
	],
	[
		{
			departure: 'AER',
			arrival: 'YKS'
		}
	]
];

export const passengersConfig: PassengerTypeConfig[] = [
	{
		code: 'ADT',
		isAdult: true,
		defaultCount: 1,
		noAvailableWith: ['SCF', 'SCM', 'МЛА']
	},
	{
		code: 'SCF',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT'],
		onlyRoutes: passTypeRoutes
	},
	{
		code: 'SCM',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT'],
		onlyRoutes: passTypeRoutes
	},
	{
		code: 'МЛА',
		parentCode: 'ADT',
		isAdult: true,
		noAvailableWith: ['ADT'],
		onlyRoutes: passTypeRoutes
	},
	{
		code: 'CLD',
		isAdult: false
	},
	{
		code: 'INF',
		isAdult: false,
		disabledRoutes: [
			[
				{
					arrival: '*',
					departure: 'АОС'
				}
			],
			[
				{
					arrival: 'АОС',
					departure: '*'
				}
			],
			[
				{
					arrival: '*',
					departure: 'БСК'
				}
			],
			[
				{
					arrival: 'БСК',
					departure: '*'
				}
			],
			[
				{
					arrival: '*',
					departure: 'АХЗ'
				}
			],
			[
				{
					arrival: 'АХЗ',
					departure: '*'
				}
			],
			[
				{
					arrival: '*',
					departure: 'ДМЙ'
				}
			],
			[
				{
					arrival: 'ДМЙ',
					departure: '*'
				}
			],
			[
				{
					arrival: '*',
					departure: 'ЭЛБ'
				}
			],
			[
				{
					arrival: 'ЭЛБ',
					departure: '*'
				}
			],

			[
				{
					arrival: '*',
					departure: 'ШГШ'
				}
			],
			[
				{
					arrival: 'ШГШ',
					departure: '*'
				}
			]
		]
	},
	{
		code: 'INS',
		isAdult: false
	}
];

export const promoLoaders: Card[] = [
	{
		type: CardType.City,
		image: 'https://cdn.websky.aero/content/frontend/images/WZ/promoLoader.jpg'
	}
];

const subscriptionLink = `https://flyredwings.com/${currentLocale}/subscription/`;

export const companyInfo: CompanyInfo = {
	subsidyFaresConditionURL: 'https://flyredwings.com/sub/dlya-kategorij-po-vozrastu/',
	facebook: 'https://www.facebook.com/flyredwings',
	instagram: 'https://www.instagram.com/flyredwings',
	vk: 'https://vk.com/flyredwings',
	baggage: `https://flyredwings.com/${currentLocale}/baggage/`,
	meal: `https://flyredwings.com/${currentLocale}/services/meal-on-board/`,
	seat: `https://flyredwings.com/${currentLocale}/services/choice-place/`,
	legal: `https://flyredwings.com/${currentLocale}/regulations/`,
	privacyPolicy: `https://flyredwings.com/${currentLocale}/privacy-policy/`,
	exarePrivacyPolicyURL: `https://flyredwings.com/${currentLocale}/regulations/`,
	exareRulesURL: `https://flyredwings.com/${currentLocale}/privacy-policy/`,
	insurance: `https://flyredwings.com/${currentLocale}/services/insurance/`,
	subsidyRulesUrl: `https://flyredwings.com/sub/dlya-kategorij-po-vozrastu/`,
	farelockURL: `https://flyredwings.com/services/fiksirovanie-stoimosti-aviabileta/`,
	transferBaggageUrl: `https://flyredwings.com/koltsovo/`,
	loyaltyProgramRegistrationUrl: ``,
	loyaltyProgramName: '',
	iataCode: 'WZ',
	loyalty: {
		links: [
			{
				title: 'Status',
				url: ``
			},
			{
				title: 'Earn miles',
				url: ``
			},
			{
				title: 'Use miles',
				url: ``
			},
			{
				title: 'FAQ',
				url: ``
			}
		]
	},
	multiInsurance: true,
	specialDocumentForInsurance: false,
	hotelsURL: 'https://redwings.ostrovok.ru/hotels'
};

export const i18n: i18next.Resource = {
	ru: {
		LoginPage: {
			'Email / Phone / Card number': 'Эл. почта',
			'Please enter a valid Email / Phone / Card number': 'Пожалуйста введите Эл. почту'
		},
		FareLock: {
			'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}':
				'Не нужно беспокоиться о повышении цены или о том, что все билеты раскупят, сейчас вы можете зафиксировать цену авиабилета на {{hours}} {{plural}}',
			'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!':
				'Внимание! Оплата <strong>только пластиковой картой</strong> (не SberPay)!',
			'Rules of service provision': 'Правила предоставления услуги'
		},
		Warnings: {
			[`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: 'Подача и внешний вид блюда могут отличаться в зависимости от аэропорта вылета'
		},
		Baggage: {
			ZIA_pet_control_warning:
				'В аэропорту Жуковского отсутствует ветеринарный контроль! С 24 августа 2017 года оформлять необходимую документацию на вывоз животного следует в других пограничных контрольных ветеринарных пунктах (аэропорт Шереметьево, Домодедово, Внуково, а также на базе Клинико-диагностического центра ФГБУ «ВГНКИ»). Важно: подобные справки действительны в течение 5 дней, включая день оформления. Мы не отказываем в перевозке животных из Жуковского, однако пассажиру надлежит прибыть в аэропорт с оформленными в другом месте документами.'
		},
		Meal: {
			'Add for all': 'Выбрать это питание для всех пассажиров'
		},
		PromoLoader: {
			'One moment please': 'Поиск рейса'
		},
		RetrieveBooking: {
			'Retrieve booking': 'Мои бронирования',
			'Booking ID': 'Номер билета или код бронирования',
			'Security code': 'Фамилия пассажира',
			Open: 'Найти заказ'
		},
		Refund: {
			'The money will be returned to the card used to pay for the ticket within 15 days':
				'Деньги будут возвращены на карту, использованную при оплате билета, в течение 15 дней.\nДополнительные услуги невозвратные',
			NeedConfirm: 'Подтвердите возврат',
			'Successful refund. Confirmation and detalization have been sent to your e-mail':
				'Успешный возврат. Детализация будет отправлена на ваш e-mail',
			'Request for refund': 'Запрос на возврат',
			'Successfully refund': 'Успешный возврат'
		},
		Exchange: {
			'Create request': 'Оплатить',
			'We couldn\'t find any flights for given dates': 'Пожалуйста, выберите другую дату вылета',
			'Successful payment': 'Успешная оплата',
			'Failed payment': 'Оплата не удалась',
			Agreement: `Я согласен с <a href="#" data-type="termsOfTariff">условиями тарифа</a> и <a href="https://flyredwings.com/services/change/" target="_blank">правилами предоставления услуги</a>`
		},
		InfoCard: {
			Add: 'Добавить документ'
		},
		Title: {
			companyName: 'Red Wings'
		},
		Stepbar: {
			Hotels: 'Отели'
		},
		Checkout: {
			'I accept the': 'Я согласен с условиями',
			'terms of tariff': 'тарифа',
			'terms of agreement': 'договора',
			'terms of insurances': 'страхования',
			'processing of my personal data': 'обработки персональных данных',
			'If you will not select a seat now, we will automatically select it for you upon check-in.':
				'Сейчас самое время выбрать место на борту! Первые - выбирают самые комфортные кресла',
			'The top ones get the top seats!': 'Первые - выбирают самые комфортные кресла',
			'Feel the taste in flight!': 'Выбирайте собственное меню!',
			'I agree with subsidy fares and rules':
				'Я ознакомлен с <a href="{{subsidyUrl}}" target="_blank">правилами и ограничениями по использованию субсидируемых тарифов</a>',
			'I agree with the rules for checking in transfer baggage at Koltsovo airport':
				'Я согласен с <a href="{{transferBaggageUrl}}" target="_blank">правилами оформления трансферного багажа в аэропорту «Кольцово»</a>',
			'Write-off of funds is made in tenge': 'Списание денежных средств производится в тенге',
			Attention: 'Внимание',
			'Online doctor': 'Врач в поездку',
			'Medical insurance': 'Медицинское страхование',
			'Business lounge with VIP services': 'Бизнес-зал с предоставлением VIP услуг',
			'Fast Track': 'Fast Track',
			Consents_Main: 'Даю свое согласие со следующими правилами и условиями:',
			Consents_TermsOfAgreement: 'Договором и правилами воздушной перевозки',
			Consents_Insurance: 'Правилами и условиями страхования',
			Consents_PrivacyPolicy: '',
			Consents_Subscribed: `Даю согласие на получение <a href="${companyInfo.privacyPolicy}" target="_blank">рекламно-информационных рассылок и обработку персональных данных</a>`
		},
		PassengersConsents: {
			Consents_Main: 'Даю свое согласие со следующими правилами и условиями:',
			Consents_TermsOfTariff: `<span data-type="termsOfTariff">Условиями тарифа</span>, <a href="${companyInfo.legal}" target="_blank">договором и правилами воздушной перевозки</a>`,
			Consents_TermsOfAgreement: '',
			Consents_Insurance: '',
			Consents_PrivacyPolicy: '',
			Consents_Subscribed: `Даю согласие на получение <a href="${subscriptionLink}" target="_blank">рекламно-информационных рассылок и обработку персональных данных</a>`
		},
		MealPage: {
			'Feel the taste in flight': 'Выбирайте собственное меню!\n\n\n'
		},
		SeatMap: {
			'Pay attention!': 'Уважаемые пассажиры, пожалуйста, обратите внимание!',
			'The airline reserves the right to replace the aircraft.': '',
			'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters':
				'В случае замены воздушного судна по причинам, связанным с обеспечением безопасности полетов, Авиакомпания предоставит пассажирам, оплатившим услугу "выбор места" - места аналогичные по стоимости и комфорту. Пассажирам будут сохранены следующие условия:',
			'- Cost of services;': '— Расположение места на борту, с учетом прохода или иллюминатора;',
			'- Location of the place relative to the window / aisle;': '— Расположение кресла на первых рядах салона;',
			'- Joint seating, if one was originally selected;': '— Совместная рассадка пассажиров;',
			'- Placement in the front row of the cabin, if one was originally selected.': '— Стоимость услуги',
			'Less than 24 hours left before the flight': 'До вылета рейса осталось менее 24 часов.',
			'You can select seats using the online registration service after issuing tickets':
				'Услуга «Выбор мест» для данного рейса будет доступна после покупки билета во время онлайн-регистрации'
		},
		PaymentForm: {
			'Credit or debit card': 'Картой онлайн\nили ваучером',
			Invoicebox: 'По счёту для организаций',
			Title_PayLate: 'В рассрочку без первоначального взноса, одобрение за полчаса',
			Header_PayLate: 'В рассрочку без первоначального взноса, одобрение за полчаса',
			Instalment: 'В рассрочку без первоначального взноса, одобрение за полчаса'
		},
		FlightPrice: {
			'Select from': 'от'
		},
		Passenger: {
			docNumber: 'Серия и номер документа',
			'Check if the input is correct': 'Проверьте правильность ввода',
			other: 'Другое',
			organizationName: 'Название Организации',
			personnelNumber: 'Табельный Номер',
			contacts: 'Контакты'
		},
		IncludedBaggage: {
			Equipment: 'Дополнительный багаж',
			'Need to bring sports, music or baby equipments?': `Вам нужно взять с собой <a href="https://flyredwings.com/${currentLocale}/baggage/sportivnoe-snaryazhenie/" target="_blank">спортивное оборудование</a> или <a href="https://flyredwings.com/${currentLocale}/baggage/perevozka-zhivotnyx/" target="_blank">домашнее животное</a>?`
		},
		SubsidySuggestPopup: {
			'Subsidy fares': 'Внимание'
		},
		SearchForm: {
			Aviatickets: 'Авиабилеты',
			Hotels: 'Отели',
			Transfer: 'Трансфер',
			'I will pay with a foreign card': 'Я буду платить иностранной картой',
			'Offer hotels': 'Предлагать гостиницы'
		},
		BaggageTotalPriceBlock: {
			Add: 'Добавить',
			edit: 'Изменить',
			from: 'От',
			'More bags': 'Багаж'
		},
		DesktopFlight: {
			Select: 'Выбрать'
		},
		FlightCard: {
			'The flight operates': 'Рейс выполняет'
		},
		FlightInfoModalContent: {
			'Back to flights': 'Вернуться к перелетам',
			'Total duration': 'Общая продолжительность',
			'Scroll up': 'Наверх'
		},
		OrderCard: {
			'Review:Waiting for payment': 'Ожидает оплаты',
			'Review:Expires at': 'Истекает',
			'Review:Expires today at': 'Истекает сегодня в',
			'Account:Waiting for payment': 'Ожидает оплаты',
			'Account:expires at': 'Истекает',
			'Account:expires today at': 'Истекает сегодня в',
			'Check-in': 'Онлайн регистрация'
		},
		Passengers: {
			Teenagers: 'Подростки',
			'Young people from twelve to eighteen years old': 'Молодые люди от 12 до 18 лет'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Подтверждаю, что являюсь сотрудником Ростеха. В ином случае Перевозчик имеет право аннулировать билет.',
			promoCheckboxLabel_YANO10:
				'Подтверждаю, что являюсь жителем Ямало-Ненецкого автономного округа. В ином случае Перевозчик имеет право аннулировать бронирование.',
			promoCheckboxLabel_РСТХИН25:
				'Подтверждаю, что являюсь сотрудником Ростеха. В ином случае Перевозчик имеет право аннулировать билет.'
		},
		QuickSearchForm: {
			PDA_0: 'Подросток',
			PDA_1: 'Подростка',
			PDA_2: 'Подростков'
		},
		TransferInfo: {
			Terminal: 'Терминал',
			Change: 'Смена'
		},
		Consents: {
			agreement_rules:
				'Я ознакомился(-лась) с {{links}}, оплатой данных доп. услуг, принимаю их и согласен с ними.',
			agreement_insurancesRules_sogaz:
				'<span><a href="https://flyredwings.com/upload/redwings/insurance/sogaz/rules.pdf" target="_blank">правилами страхования АО «СОГАЗ»</a></span>',
			agreement_insurancesRules_alpha:
				'<span><a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">правилами АО «АльфаСтрахование»</a></span>',
			agreement_insurancesRules: '{{alphaGeneralRules}}{{sogazGeneralRules}}{{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	en: {
		LoginPage: {
			'Email / Phone / Card number': 'Email',
			'Please enter a valid Email / Phone / Card number': 'Please enter a valid Email'
		},
		Stepbar: {
			Hotels: 'Hotels'
		},
		Baggage: {
			ZIA_pet_control_warning:
				'Please note that there is no pet control service at Zhukovskiy Airport. You should to pass veterinary control and obtain required documents at other nearest airports: Sheremetyevo, Domodedovo, Vnukovo. Pet control documents is valid for 5 days.'
		},
		PromoLoader: {
			'One moment please': 'Flight Search'
		},
		FareLock: {
			'Rules of service provision': 'Rules of service provision',
			'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!':
				'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!'
		},
		Warnings: {
			[`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: `The serving and appearance of the dish may vary depending on the departure airport`
		},
		RetrieveBooking: {
			'Retrieve booking': 'My bookings',
			'Booking ID': 'Ticket number or booking id',
			'Security code': 'Last name',
			Open: 'Find booking'
		},
		Title: {
			companyName: 'Red Wings'
		},
		FlightPrice: {
			'Select from': 'from'
		},
		Checkout: {
			'I agree with subsidy rules': 'I agree with<a href="{{subsidyUrl}}" target="_blank"> subsidy rules</a>',
			'I agree with the rules for checking in transfer baggage at Koltsovo airport':
				'I agree with <a href="{{transferBaggageUrl}}" target="_blank">rules for checking in transfer baggage at Koltsovo airport</a>',
			'Write-off of funds is made in tenge': 'Write-off of funds is made in tenge',
			Attention: 'Attention',
			'Online doctor': 'Online doctor',
			'Medical insurance': 'Medical insurance',
			'Business lounge with VIP services': 'Business lounge with VIP services',
			'Fast Track': 'Fast Track'
		},
		PassengersConsents: {
			Consents_Main: 'I give my consent to the following terms and conditions:',
			Consents_TermsOfTariff: `<span data-type="termsOfTariff">The fare conditions</span>, <a href="${companyInfo.legal}" target="_blank">contract, and air transport rules</a>`,
			Consents_TermsOfAgreement: '',
			Consents_Insurance: '',
			Consents_PrivacyPolicy: '',
			Consents_Subscribed: `I consent to receiving <a href="${subscriptionLink}" target="_blank">advertising and informational newsletters and the processing of personal data</a>`
		},
		IncludedBaggage: {
			Equipment: 'Extra baggage'
		},
		SubsidySuggestPopup: {
			'Subsidy fares': 'Attention'
		},
		BaggageService: {
			From: 'From',
			Total: 'Total',
			Edit: 'Edit',
			Cancel: 'Cancel',
			Confirm: 'Confirm',
			'Different for return flight': 'Different for return flight',
			'Transportation of skis / snowboards': 'Transportation of skis / snowboards',
			'Special inventory': 'Sport equipment'
		},
		DesktopFlight: {
			Select: 'Select'
		},
		FlightCard: {
			'The flight operates': 'The flight operates'
		},
		FlightInfoModalContent: {
			'Back to flights': 'Back to flights',
			'Total duration': 'Total duration',
			'Scroll up': 'Scroll up'
		},
		Forms: {
			'To check in for a Smartavia flight, please visit their official website':
				'To check in for a Smartavia flight, please visit their official website'
		},
		OrderCard: {
			'Review:Waiting for payment': 'Waiting for payment',
			'Review:Expires at': 'Expires at',
			'Review:Expires today at': 'Review:Expires today at',
			'Account:Waiting for payment': 'Waiting for payment',
			'Account:expires at': 'expires at'
		},
		Passenger: {
			other: 'Other',
			'Latin symbols and digits': 'Latin symbols and digits',
			organizationName: 'Organization Name',
			personnelNumber: 'Personnel Number',
			contacts: 'Contacts'
		},
		Passengers: {
			Teenagers: 'Teenagers',
			'Young people from twelve to eighteen years old': 'Young people from twelve to eighteen years old',
			'12-18 years': '12-18 years'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.',
			promoCheckboxLabel_YANO10:
				'I confirm that I am a resident of the Yamalo-Nenets Autonomous Okrug. Otherwise, the Carrier has the right to cancel the booking.',
			promoCheckboxLabel_РСТХИН25:
				'I confirm that I am an employee of Rostec. Otherwise, the Carrier has the right to cancel the ticket.'
		},
		QuickSearchForm: {
			PDA: 'Teenager',
			PDA_plural: 'Teenagers'
		},
		Refund: {
			'Privacy Policy': 'privacy policy'
		},
		Exchange: {
			Agreement: `I agree with the <a href="#" data-type="termsOfTariff">terms of tariff</a> and <a href="https://flyredwings.com/en/services/change/" target="_blank">Terms of Service</a>`
		},
		SearchFormDatepicker: {
			'Approximate prices for 1 person for 1 direction': 'Approximate offers for one person for direct flights'
		},
		TransferInfo: {
			Terminal: 'Terminal',
			Change: 'Change'
		},
		PaymentForm: {
			Title_PayLate: 'By in credit without down payment, approval within half an hour',
			Header_PayLate: 'By in credit without down payment, approval within half an hour',
			Instalment: 'By in credit without down payment, approval within half an hour'
		},
		SearchForm: {
			Aviatickets: 'Aviatickets',
			Hotels: 'Hotels',
			Transfer: 'Transfer',
			'I will pay with a foreign card': 'I will pay with a foreign card'
		},
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules_sogaz:
				'<span><a href="https://flyredwings.com/upload/redwings/insurance/sogaz/rules.pdf" target="_blank">rules of insurance of «SOGAZ»</a></span>',
			agreement_insurancesRules_alpha:
				'<span><a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance of «AlfaStrakhovanie»</a></span>',
			agreement_insurancesRules: '{{alphaGeneralRules}}{{sogazGeneralRules}}{{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	kk: {
		...kk,
		Title: {
			companyName: 'Red Wings'
		},
		Checkout: {
			'Business lounge': 'Бизнес залы'
		},
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules:
				'<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		PassengersConsents: {
			Consents_Main: 'Мен келесі шарттармен келісемін:',
			Consents_TermsOfTariff: `<span data-type="termsOfTariff">Тариф шарттары</span>, <a href="${companyInfo.legal}" target="_blank">Келісім және әуе тасымалы ережелері</a>`,
			Consents_TermsOfAgreement: '',
			Consents_Insurance: '',
			Consents_PrivacyPolicy: '',
			Consents_Subscribed: `Мен <a href="${subscriptionLink}" target="_blank">жарнамалық және ақпараттық хабарларды алуға және жеке деректерді өңдеуге</a> келісемін.`
		},
		FareLock: {
			'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!':
				'Назар аударыңыз! Төлем <strong>тек пластикалық карта менжүзеге асырылады</strong> (SberPay емес)!',
			'Rules of service provision': 'Қызмет көрсету ережелері'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Мен Ростех компаниясының қызметкері екенімді растаймын. Басқа жағдайда Тасымалдаушы билетті жою құқығына ие.',
			promoCheckboxLabel_YANO10:
				'Мен Ямал-Ненец автономды округінің тұрғынымын деп растаймын. Басқа жағдайда Тасымалдаушы брондауды жоюға құқылы.',
			promoCheckboxLabel_РСТХИН25:
				'Мен Ростех қызметкері екенімді растаймын. Басқа жағдайда Тасымалдаушы билетті жоюға құқылы.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	de: {
		Refund: {
			'Ticket price': 'Order price'
		},
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules:
				'<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Ich bestätige, dass ich Mitarbeiter von Rostec bin. Andernfalls hat der Beförderer das Recht, das Ticket zu stornieren.',
			promoCheckboxLabel_YANO10:
				'Ich bestätige, dass ich Einwohner des Autonomen Kreises Jamal-Nenzen bin. Andernfalls hat der Beförderer das Recht, die Buchung zu stornieren.',
			promoCheckboxLabel_РСТХИН25:
				'Ich bestätige, dass ich Mitarbeiter von Rostec bin. Andernfalls hat der Beförderer das Recht, das Ticket zu stornieren.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	fr: {
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules:
				'<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Rostech çalışanı olduğumu onaylıyorum. Aksi halde Taşıyıcının bileti iptal etme hakkı vardır.',
			promoCheckboxLabel_YANO10:
				'Je confirme que je suis résident du district autonome de Yamalo-Nenets. Dans le cas contraire, le Transporteur a le droit d’annuler la réservation.',
			promoCheckboxLabel_РСТХИН25:
				'Je confirme que je suis employé de Rostec. Dans le cas contraire, le transporteur a le droit d’annuler le billet.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	zh: {
		Consents: {
			agreement_rules:
				'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
			agreement_insurancesRules:
				'<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
			agreement_interpolation: '{{insurancesRules}}',
			agreement_additionalInsuranceRules: '{{link}}',
			agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
		},
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ: '我确认我是 Rostech 的员工。否则，承运人有权取消机票。',
			promoCheckboxLabel_YANO10: '我确认自己是亚马尔-涅涅茨自治区的居民。否则，承运人有权取消预订。',
			promoCheckboxLabel_РСТХИН25: '我确认自己是俄罗斯国家技术集团的员工。否则，承运人有权取消车票。'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	be: {
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ: `Пацвярджаю, што з'яўляюся супрацоўнікам Растэха. У іншым выпадку Перавозчык мае права ануляваць білет.`,
			promoCheckboxLabel_YANO10:
				'Пацвярджаю, што з’яўляюся жыхаром Ямала-Нянецкай аўтаномнай акругі. У іншым выпадку Перавозчык мае права ануляваць браніраванне.',
			promoCheckboxLabel_РСТХИН25:
				'Пацвярджаю, што з’яўляюся супрацоўнікам Растэха. У адваротным выпадку перавозчык мае права ануляваць білет.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	cs: {
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Potvrzuji, že jsem pracovníkem společnosti Rostech. V opačném případě má Dopravce právo letenku stornovat..',
			promoCheckboxLabel_YANO10:
				'Potvrzuji, že jsem obyvatelem Jamalo-něneckého autonomního okruhu. V opačném případě má Dopravce právo zrušit rezervaci.',
			promoCheckboxLabel_РСТХИН25:
				'Potvrzuji, že jsem zaměstnanec společnosti Rostec. V opačném případě má dopravce právo zrušit jízdenku.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	tg: {
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'Тасдиқ мекунам, ки корманди Ростех мебошам. Дар акси ҳол Интиқолдиҳанда ҳуқуқ дорад чиптаро бекор кунад.',
			promoCheckboxLabel_YANO10:
				'Тасдиқ менамоям, ки сокини ноҳияи худмухтори Ямало-Ненетс мебошам. Дар акси ҳол, Нақлиётчи ҳуқуқ дорад фармоишро бекор кунад.',
			promoCheckboxLabel_РСТХИН25:
				'Тасдиқ мекунам, ки ман корманди Ростех ҳастам. Дар акси ҳол, Нақлиёткунанда ҳуқуқ дорад чиптаро бекор кунад.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	},
	ko: {
		PromoCode: {
			promoCheckboxLabel_РОСТЕХ:
				'저는 Rostech의 직원임을 확인합니다. 그렇지 않으면 항공사는 티켓을 취소할 권리가 있습니다.',
			promoCheckboxLabel_YANO10:
				'나는 야말로-네네츠 자치구의 거주자임을 확인합니다. 그렇지 않은 경우, 운송업자는 예약을 취소할 권리가 있습니다.',
			promoCheckboxLabel_РСТХИН25:
				'저는 로스텍 직원임을 확인합니다. 그렇지 않은 경우 운송사는 티켓을 취소할 권리가 있습니다.'
		},
		Account: {
			TinkoffID: 'T-ID'
		}
	}
};

export const defaultSteps: Steps = {
	flights: {
		label: 'Flights'
	},
	seats: {
		label: 'Seats'
	},
	baggage: {
		label: 'Baggage'
	},
	meal: {
		label: 'Meal'
	},
	passengers: {
		label: 'Passengers'
	},
	payment: {
		label: 'Payment'
	}
};

export const config: Config = {
	global: {
		seatMap: {
			showRecommendedSeats: true,
			showPriceInSeat: true
		},
		showTaxesInfo: true,
		additionalResources: {
			scripts: ['https://secure.sirena-travel.ru/media/js/pg-additional-1.0.min.js'],
			extraScripts: []
		},
		socialAuthCallbackUrl: 'https://www.flyredwings.com/social-auth',
		socialAuthMethods: [
			{
				service: OauthServiceType.Vkontakte,
				isAvailable: true
			},
			{
				service: OauthServiceType.TinkoffID,
				isAvailable: true
			}
		],
		authMethods: {
			phone: false,
			ffp: false
		},
		showIsActualizationResultOk: false,
		allowPromoCodes: true,
		companyInfo,
		maxBaggagePerPassenger: 4,
		yandexMetrikaId: isProd ? ['17480347', '98693817'] : undefined,
		varioqubId: isProd ? '98693817' : undefined,
		insurance: {
			upsaleStrategy: ['checkout-before-payment'],
			multiplePriorityInsurances: true
		},
		i18n,
		reserveEngines: {
			siteUrl: `https://flyredwings.com/${currentLocale}`
		},
		findOrderURL: `https://flyredwings.com/${currentLocale}/booking/#/find/`,
		checkoutAdditionalService: {
			insurance: {
				insuranceProgramCodeMap: {
					['ON_TELEMED_NS_SR_2']: {
						header: 'Online doctor',
						headerIcon: doctorHeaderIcon,
						contentIcon: doctorContentIcon,
						color: '#F28D6D'
					},
					['RW_VZR']: {
						header: 'Medical insurance',
						color: '#77C6B3',
						headerIcon: null,
						contentIcon: medical_insurance
					}
				}
			}
		},
		purchasePredictionThreshold: 0.01,
		purchasePredictionThresholdMax: 1,
		showLeavePageModal: true
	},
	Account: {
		engineURL: 'https://flyredwings.com/booking/',
		showSubscribeCheckbox: true,
		showUserPhoneInput: false
	},
	Engine: {
		mealWarning: `Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`,
		promoLoaders: promoLoaders,
		defaultSteps,
		checkInEnabled: true,
		checkInURL: 'https://flyredwings.com/check-in',
		showRefundRedirectButton: true,
		showAvailableFaresOnly: true,
		resultsDefaultSorting: Sorting.FlightTime
	},
	SearchForm: {
		engineURL: 'https://flyredwings.com/booking/',
		showPriceGraph: true,
		showPricesInDatepicker: true,
		passengersConfig: passengersConfig,
		enableComplexRoute: false,
		requestCoordintates: {
			desktop: false
		},
		resultsURL: 'https://flyredwings.kz/booking/',
		offerHotels: true,
		offerHotelsDefaultState: false,
		offerHotelsSupplier: 'OSTROVOK',
		offerHotelsLink: 'https://redwings.ostrovok.ru/hotels',
		offerHotelsMainLink: 'https://redwings.ostrovok.ru',
		offerHotelsAdditionalId: '62c561aea0b084090d491722',
		promoCodesWithAgreement: [
			{
				regex: /^РОСТЕХ$/i,
				code: 'РОСТЕХ'
			},
			{
				regex: /^YANO10$/i,
				code: 'YANO10'
			},
			{
				regex: /^РСТХИН25$/i,
				code: 'РСТХИН25'
			}
		]
	},
	FlightStatus: {
		playMarketURL: '',
		appStoreURL: ''
	}
};
